import React, { useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, } from "@mui/material";
import {
    SaveRounded,
} from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";

const title = "Company Group";

const Function = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [leadModal, setLeadModal] = useState(false);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [formData, setFormData] = useState({
        leadName: "",
        leadOwner: null,
        leadSource: null,
        contactName: null,
        clientCompany: "",
        leadStatus: "",
        stage: "",
        priority: "",
        lossReason: "",
        productType: "",
        expectedTimeline: "",
        productRadio: "0",
        leadDescription: "",
    });

    const columns = useMemo(
        () => [
            { accessorKey: 'sn', header: 'SN', size: 50 },
            { accessorKey: 'shortName', header: 'Short Name', size: 120 },
            { accessorKey: 'groupName', header: 'Group Name', size: 180 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <VisibilityIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );

    const data = [
        {
            sn: "1",
            date: "23/03/2024",
            company: "KG 2",
            mobile: "37263274",
            leadSource: "New",
            leadOwner: "new",
            status: "In progress",
            priority: "low",
            lossReason: "low quality",
            createdBy: "KG",
        },
        {
            sn: "2",
            date: "23/03/2024",
            company: "AG",
            mobile: "37263274",
            leadSource: "AG pvt",
            leadOwner: "AG Pvt",
            status: "In progress",
            priority: "low",
            lossReason: "Transportation delayed",
            createdBy: "AG",
        },
    ]; 

    const handleViewClick = (id) => {
        navigate(`/app/abc/${id}`);
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    }; 

    return (
        <>
            <Box sx={{ paddingLeft: "10px" }} >
                <form>
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <CustomTextField
                                type="text"
                                name="shortName"
                                fieldLabel="Short Name:"
                                value={formData.shortName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Short Name"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <CustomTextField
                                type="text"
                                name="clientCompanyGroups"
                                fieldLabel="Client Company Groups:"
                                value={formData.clientCompanyGroups}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Client Company Groups"
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <br />
                            <CustomButton
                                startIcon={<SaveRounded />}
                                title="Save"
                                size="small"
                                variant="contained"
                            />
                        </Grid>
                    </Grid>
                </form>

            </Box>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={data}
                />

            </Box>
        </>
    );
};
export default Function;

 